import script from "./AddBill.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBill.vue?vue&type=script&setup=true&lang=js"

import "./AddBill.vue?vue&type=style&index=0&id=ab0bf626&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab0bf626"]])

export default __exports__